import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoBackArrow from '../GoBackArrow/go.back.arrow.vue';
@Component({
    components: {
        GoBackArrow
    }
})
export default class HybridHeaderBar extends Vue {

    @Prop({ default: '标题' })
    public title!: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
